import styled from "styled-components";
export const DashboardContainer = styled.div`
  padding-top: 87px;
`;
export const CompainesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 250px);
  grid-row-gap: 2.6rem;
  grid-column-gap: 3rem;
  justify-content: center;
  padding: 1rem;
`;
export const CompaniesHeader = styled.h1`
  font-size: 36px;
  text-align: center;
  margin: 3rem 0;
`;
